import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.FirmDocumentShow })));

export default { edit };
